import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The only components in this skin allowed to render a number.
 *
 * Everything numeric goes through one of these, and none of them accepts a JS `number`.
 * That is the whole enforcement mechanism for invariant 5 on the front end: if a
 * component wants to show an amount it must hold a `Paise`, and if it wants to show a
 * quantity or a rate it must hold a `Dec`. There is no path from a float to the screen,
 * because there is no prop that would take one.
 */
import { Box, Typography } from '@mui/material';
import { formatDecimal, formatPaise, formatRate, } from '@inai/inventory-core';
export function MoneyText({ value, zeroAs, omitSymbol, sx, signedColor }) {
    const text = formatPaise(value, {
        ...(zeroAs !== undefined ? { zeroAs } : {}),
        ...(omitSymbol !== undefined ? { omitSymbol } : {}),
    });
    return (_jsx(Box, { component: "span", sx: [
            // Tabular figures so a column of amounts lines up on the decimal point.
            { fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
            signedColor && value < 0n ? { color: 'error.main' } : {},
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: text }));
}
export function QuantityText({ value, uom, places, signed, signedColor, hideUnit, sx, }) {
    const text = formatDecimal(value, {
        places: places ?? uom?.decimal_places ?? 4,
        trim: true,
        ...(signed !== undefined ? { signed } : {}),
        ...(!hideUnit && uom?.code ? { unit: uom.code } : {}),
    });
    return (_jsx(Box, { component: "span", sx: [
            { fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
            signedColor && value.isNegative ? { color: 'error.main' } : {},
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: text }));
}
export function RateText({ value, sx }) {
    return (_jsx(Box, { component: "span", sx: [
            { fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], children: formatRate(value) }));
}
export function Stat({ label, children, hint, emphasis }) {
    return (_jsxs(Box, { sx: { minWidth: 132 }, children: [_jsx(Typography, { sx: { fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.6 }, color: "text.secondary", children: label }), _jsx(Typography, { sx: {
                    fontSize: emphasis ? 24 : 19,
                    fontWeight: emphasis ? 800 : 600,
                    lineHeight: 1.3,
                    mt: 0.25,
                }, children: children }), hint ? (_jsx(Typography, { sx: { fontSize: 11, mt: 0.25, lineHeight: 1.35 }, color: "text.secondary", children: hint })) : null] }));
}
//# sourceMappingURL=Numbers.js.map